(function($) {
	var ponyIds = 0;
	var ponyTemplateSource =
		"<div class=\"pony\" id=\"{{ id }}\">\n\t<ol class=\"pony-selector row\" aria-label=\"{{ select.label }}\" role=\"listbox\" data-pony-write-reference=\"{{ select.reference }}\" aria-multiselectable=\"{{# if select.multiple }}true{{ else }}false{{/ if }}\">\n\t\t{{# each select.options }}\n\t\t\t{{# if this.value }}\n\t\t\t\t<li class=\"pony-option large-6 columns\" role=\"option\" data-pony-write-value=\"{{ this.value }}\" aria-selected=\"{{# if this.selected }}true{{ else }}false{{/ if }}\">\n\t\t\t\t\t<span>{{ this.label }}</span>\n\t\t\t\t</li>\n\t\t\t{{/ if }}\n\t\t{{/ each }}\n\n\t\t{{# if custom }}\n\t\t<li class=\"pony-option pony-custom large-6 columns\" role=\"option\" aria-selected=\"{{# if custom.selected }}true{{ else }}false{{/ if }}\">\n\t\t\t<span>\n\t\t\t\t{{ custom.label }}<br />\n\t\t\t\t<input type=\"{{ custom.type }}\" placeholder=\"{{ custom.placeholder }}\" value=\"{{ custom.value }}\" data-pony-write-reference=\"{{ custom.reference }}\" data-pony-write-self />\n\t\t\t</span>\n\t\t</li>\n\t\t{{/ if }}\n\t</ol>\n</div>";
	var toggablePonyTemplateSource =
		"<div class=\"row pony\" id=\"{{ id }}\">\n\t<div class=\"large-6 columns\">\n\t\t<div class=\"pony-option {{# if isValueChoice }} pony-custom {{/ if }}\" role=\"radio\" data-pony-toggle=\"on\" data-pony-write-reference=\"{{ toggleOn.reference }}\" data-pony-write-self aria-checked=\"{{# if toggleOn.selected }}true{{ else }}false{{/ if }}\">\n\t\t\t<span>\n\t\t\t\t{{ toggleOn.label }}\n\t\t\t\t{{# if isValueChoice }}\n\t\t\t\t\t<br />\n\t\t\t\t\t<input type=\"{{ ../custom.type }}\" placeholder=\"{{ ../custom.placeholder }}\" value=\"{{ ../custom.value }}\" data-pony-write-reference=\"{{ ../custom.reference }}\" data-pony-write-self />\n\t\t\t\t{{/ if }}\n\t\t\t</span>\n\t\t</div>\n\t\t\n\t\t{{# if select }}\n\t\t\t<div class=\"pony-toggled\" data-pony-toggle-state=\"{{# if ../toggleOn.selected }}on{{ else }}off{{/ if }}\">\n\t\t\t\t<ol class=\"pony-selector\" aria-label=\"{{ select.label }}\" role=\"listbox\" data-pony-write-reference=\"{{ select.reference }}\" aria-multiselectable=\"{{# if select.multiple }}true{{ else }}false{{/ if }}\">\n\t\t\t\t\t{{# each select.options }}\n\t\t\t\t\t\t{{# if this.value }}\n\t\t\t\t\t\t\t<li class=\"pony-option\" role=\"option\" data-pony-write-value=\"{{ this.value }}\" aria-selected=\"{{# if this.selected }}true{{ else }}false{{/ if }}\">\n\t\t\t\t\t\t\t\t<span>{{ this.label }}</span>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t{{/ if }}\n\t\t\t\t\t{{/ each }}\n\t\n\t\t\t\t\t{{# if custom }}\n\t\t\t\t\t\t<li class=\"pony-option pony-custom\" role=\"option\" aria-selected=\"{{# if ../custom.selected }}true{{ else }}false{{/ if }}\">\n\t\t\t\t\t\t\t<span>\n\t\t\t\t\t\t\t\t{{ ../custom.label }}<br />\n\t\t\t\t\t\t\t\t<input type=\"{{ ../custom.type }}\" placeholder=\"{{ ../custom.placeholder }}\" value=\"{{ ../custom.value }}\" data-pony-write-reference=\"{{ ../custom.reference }}\" data-pony-write-self />\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t{{/ if }}\n\t\t\t\t</ol>\n\t\t\t</div>\n\t\t{{/ if }}\n\t</div>\n\n\t<div class=\"large-6 columns\">\n\t\t<div class=\"pony-option\" role=\"radio\" data-pony-toggle=\"off\" data-pony-write-reference=\"{{ toggleOff.reference }}\" data-pony-write-self aria-checked=\"{{# if toggleOff.selected }}true{{ else }}false{{/ if }}\">\n\t\t\t<span>\n\t\t\t\t{{ toggleOff.label }}\n\t\t\t</span>\n\t\t</div>\n\t</div>\n</div>";
	var toggablePonyTemplate = Handlebars.compile(toggablePonyTemplateSource);
	var ponyTemplate = Handlebars.compile(ponyTemplateSource);

	var Pony = function($pony, options) {
		var pony = this;
		var $ponyCustom = $pony.find(".pony-custom");
		var $ponySelector = $pony.find(".pony-selector");

		function writeToModel(reference, value, state) {
			var $reference = $("#" + reference);

			if($reference.is("[type='radio']")) {
				if(state) {
					$("input[type='radio'][name='" + $reference.attr("name") + "']").prop("checked", false);
					$reference.prop("checked", true);
				}
			} else if($reference.is("select")) {
				if(!$reference.is("[multiple]")) {
					$reference.find("option:not([value='" + value + "'])")
						.prop("selected", false)
						.removeAttr("selected");
				}

				if(state) {
					$reference.find("option[value='" + value + "']")
						.prop("selected", true)
						.attr("selected", "selected");
				} else {
					$reference.find("option[value='" + value + "']")
						.prop("selected", false)
						.removeAttr("selected");
				}
			} else {
				$reference.val(value);
			}

			$reference.trigger("change");
		}

		function readModelData($option) {
			var value = $option.is("[data-pony-write-value]")
				? $option.attr("data-pony-write-value")
				: $option.is("[data-pony-write-self]")
				? $option.val()
				: null;

			var reference = $option.is("[data-pony-write-reference]")
				? $option.attr("data-pony-write-reference")
				: $option.closest("[data-pony-write-reference]").length
				? $option.closest("[data-pony-write-reference]").attr("data-pony-write-reference")
				: null;

			return { reference: reference, value: value };
		}

		this.toggleDependencies = function(isOn) {
			isOn = typeof isOn === "string" ? isOn === "on" : false;

			$pony.find(".pony-toggled").attr("data-pony-toggle-state", isOn ? "on" : "off");

			var $selectorRef = $("#" + $ponySelector.attr("data-pony-write-reference"));
			var $customRef = $("#" + $ponyCustom.find("input").attr("data-pony-write-reference"));

			if(isOn) {
				$selectorRef.prop("disabled", false);
				$customRef.prop("disabled", false);
			} else {
				$selectorRef.prop("disabled", true);
				$customRef.prop("disabled", true);
			}
		};

		this.selectOption = function($option) {
			if($option.is("[role='option']")) {
				$option.attr("aria-selected", "true");
			} else if($option.is("[role='radio']")) {
				$option.attr("aria-checked", "true");
			}

			if($option.closest("[data-pony-toggle-state='off']").length) {
				this.selectOption($($pony.find("[data-pony-toggle='on']")));
			}

			if($option.is("[role='option']") && $ponySelector.is("[aria-multiselectable='false']")) {
				$ponySelector.find(".pony-option").each(function() {
					if(!$option.is(this)) {
						pony.deselectOption($(this));
					}
				});
			}

			if($option.is("[data-pony-toggle]")) {
				pony.toggleDependencies($option.attr("data-pony-toggle"));
				pony.deselectOption(
					$pony.find("[data-pony-toggle='" + {off: "on", "on": "off"}[$option.attr("data-pony-toggle")] +"']")
				);
			}

			var modelData = readModelData($option);

			if(modelData.reference) {
				writeToModel(modelData.reference, modelData.value, true);
			}
		};

		this.deselectOption = function($option) {
			var modelData;

			if($option.is("[role='option']")) {
				$option.attr("aria-selected", "false");
			} else if($option.is("[role='radio']")) {
				$option.attr("aria-checked", "false");
			}

			if($option.is(".pony-custom")) {
				var $input = $option.find("input");
				modelData = readModelData($input);

				writeToModel(modelData.reference, "", false);
				$input.val("");
			}

			modelData = readModelData($option);

			if(modelData.reference) {
				writeToModel(modelData.reference, modelData.value, false);
			}
		};

		if(options.disabled) return;

		$pony.on("click", [
			".pony-option[role='radio']",
			".pony-selector[aria-multiselectable='false'] .pony-option:not(.pony-custom)",
			".pony-selector[aria-multiselectable='true'] .pony-option[aria-selected='false']:not(.pony-custom)"
		].join(", "), function() {
			pony.selectOption($(this));
		});

		$pony.on("click", [
			".pony-selector[aria-multiselectable='true'] .pony-option[aria-selected='true']:not(.pony-custom)"
		].join(", "), function() {
			pony.deselectOption($(this));
		});

		$pony.on("change keyup mouseup", ".pony-option.pony-custom input", function() {
			var isSelected = $ponyCustom.attr("aria-selected") === "true";
			var value = $.trim($(this).val());

			writeToModel($(this).attr("data-pony-write-reference"), value, true);

			if(!isSelected && value !== "") {
				pony.selectOption($ponyCustom);
			} else if(isSelected && value === "") {
				pony.deselectOption($ponyCustom);
			}
		});
	};

	(function() {
		var methods = {
			initialize: function(options) {
				return this.each(function () {
					var $this = $(this);
					var options = options || {};
					options.disabled = $this.attr("data-pony-disabled") === "true";

					function getLabel($element) {
						var $label = $("label[for='" + $element.attr("id") + "']");

						if(!$label.length) $label = $element.closest("label");
						if(!$label.length) $label = $("#" + $element.attr("aria-labelledby"));

						return $label.length ? $label.text() : "";
					}

					var $toggleOn = $this.find("[data-toggle='on']");
					var $toggleOff = $this.find("[data-toggle='off']");
					var $select = $this.find("[data-pony-component='select']");
					var $custom = $this.find("[data-pony-component='custom']");

					var configuration = {
						id: "pony-" + ponyIds++
					};

					if($toggleOn.length && $toggleOff.length) {
						configuration.isToggable = true;
						configuration.toggleOn = {
							selected: $toggleOn.is(":checked"),
							reference: $toggleOn.attr("id"),
							value: $toggleOn.attr("value"),
							label: getLabel($toggleOn)
						};

						configuration.toggleOff = {
							selected: $toggleOff.is(":checked"),
							reference: $toggleOff.attr("id"),
							value: $toggleOff.attr("value"),
							label: getLabel($toggleOff)
						};
					} else {
						configuration.isToggable = false;
					}

					if($select.length) {
						configuration.select = {
							label: getLabel($select),
							multiple: $select.is("[multiple]"),
							reference: $select.attr("id"),
							options: $select.find("option").map(function() {
								var $option = $(this);
								return {
									selected: $option.is("[selected]"),
									value: $option.val(),
									label: $option.text()
								};
							}).get()
						};
					}

					if($custom.length) {
						configuration.custom = {
							selected: $.trim($custom.val()) !== "",
							value: $.trim($custom.val()),
							placeholder: $.trim($custom.attr("placeholder")),
							reference: $custom.attr("id"),
							type: $custom.is("[type]") ? $custom.attr("type") : "text",
							label: getLabel($custom)
						};
					}

					configuration.isValueChoice = configuration.isToggable && configuration.hasOwnProperty("custom") && !configuration.hasOwnProperty("select");

					options.configuration = configuration;
					var $pony = $(configuration.isToggable ? toggablePonyTemplate(configuration) : ponyTemplate(configuration));
					$pony.attr("aria-disabled", options.disabled);

					$this
						.attr("data-pony-reference", configuration.id)
						.hide()
						.after($pony);

					var pony = new Pony($pony, options);
					$pony.data("pony", pony);
				});
			},
			destroy: function() {

			}
		};

		$.fn.pony = function(method) {
			if (methods[method]) {
				return methods[method].apply(this, [].slice.call(arguments, 1));
			} else {
				return methods.initialize.apply(this, arguments);
			}
		};
	})();
})(window.jQuery);
/*

                                           ▒▒▒
                                      ▄██▒░░░▒█████████▄▄
                                  ▄███▓▓▒░░░▒▓▓▓▓█▓▓▓▓▓████▄
                              ▄██▓▓▓▓▓▒░▒░░▒▓▓██▓▓▓▓██▓▓▓▓▓███▄▄
                           ███▓█▓▓▓▓▓▒░░▒░░▒█▓▓▓▓██▓▓▓▓▓██▓▓▓▓▓██▄
                          ▐█▓▓█▓▓▓▓▓▒░░░░▒▒▒▓▓▓██▓▓████████████████▄
                     ▄█▄ █▓▓█▓▓▓▓▓▓▒▒░░░░░▒▓██▓▓███▓█▓▓▓▓█▓▓▓▓▓▓▓▓█▄
                  ▄██████▓▓█▓▓▓▓▓▓▒░▒░░░░░▒▓▓██▓▓▓█▓▓▓▓█▓▓▓▓▓▓▓▓▓█▀
                ▄█▓▓████▓▓█▓▓▓▓▓▓▒░░▒▒░░░░▒▓█▓▓▓▓▓█▓▓▓█▓▓▓▓▓▓▓▓█▀
               ▄█▓▓▓████▓█▓▓▓▓▓▓▒▒░░░░▒▒▒▒▒█▓▓▓▓▓█▓▓▓█▓▓▓▓▓▓▓█▀
              ██▓▓▓▓███▓█▓▓▓▓▓▓▓▒░▒░░░░░░▒▒▓▓▓▓▓▓█▓▓█▓▓▓▓▓▓▓█
            ██▓▓▓▓▓▓███▓█▓▓▓▓▓▓▒▒░░▒░░░░▒▒▓▓▓▓▓▓▓█▓█▓▓▓▓▓▓███       ▄▄▄▄
            █▓▓▓▓▓▓▓███▓█▓▓▓▓▓▓▒▒░░░░▒▒▒▒▒▓▓▓▓▓▓▓█▓█▓▓▓▓▓██▓▓█████▓▓▓▓█
           ██▓▓▓▓▓▓▓████▓▓▓▓▓▓▒▒░░░░░░░░▒▒▓▓▓▓▓▓▓█▓█▓▓▓▓▓█▓▓▓▓██▓▓█▓▓▓▓█
          █▓▓█▓▓▓▓▓▓▓███▓▓▒▒▒▒░░░░░░░░░░░▒▒▒▒▒▓▓▓▓█▓█▓▓▓██▓▓▓▓████▓▓▓▓▓█
         ██▓▓▓█▓▓▓▓▓▓██▒▒▒▒░░░░░░░░░░░░░░░░░░▒▒▒▒▓▓█▓█▓▓██████████▓▓▓▓██
         █▓█▓▓▓█▓▓▓▓▓▒▒▒░░░░░░░░░░░░░░░░░░░░░░░░░▒▒▓█▓█▓██▓▓▓▓▓▓▓▓▓▓██
        █▓▓▓██▓▓██▓▒▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░░▒▒▓█▓█▓█▓▓▓▓▓▓▓▓██
        █▓▓▓▓▓███▓▒▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░▒▒██▓█▓██▓▓████
   ▒▒▒▒▒▓▓▓▓▓▓▓▒▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░▒▒▀▀▀▀▀▀▀▀
  ▒░░░░░░▒▒▒▓▓▒▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░▒▒
  ▒░░░░░░░░░▒▒▒░░░░░░░░░░░░░░░░░▄░░░▄░░░░░░░░░░░░░░░░░▒
   ▒░░░░░░░░░░▒▒░░░░░░░░░░░░░▀▄░░▀▄▄▀▄▄▄▄▄░░░░░░░░░░░░░▒▒▒▒▒▒▒
   ▒░░░░░░░░░░░░░░░░░░░░░░▀▄▄░░██████████████▄░░░░░░░░░░░░░░░░▒
   ▒▒░░░░░░░░░░░░░░░░░░▄▄░░░▄████▓▓▓▓▓▓▓▓▓    ▀█▄░░░░░░░░░░▅▅░░░▒
    ▒▒░▒▒░░░░░░░░░░░░░░░░▀███▓   ▀██████▓▓▓▓▓     ▀▅░░░░░░░░░░░░▒▒
     ▒░░░▒▒▒░░░░░░░░░▀▀▀▀▀░░▓▓     ▀███████▓▓▓▓     ▀▅░░░░░░░░░░░▒
      ▒▒░░░░▒▒▒▒░░░░░░░░░░░░░▓      ███▀▀███▓▓▓▓      ▀░░░░▅▅▅▅▅▅▀▀▒
       █▒▒░░░░░░░▒▒▒░░░░░░░░░░░     ███▄ ▐███▓▓▓▓    ░░░░░░░░░░░▒
       █▓▓▒▒░░░░░░░░░░░░░░░░░░░░░▀█████████▓▓▓▓  ░░░░░░░░░░░░▒
       █▓▓▓▓▒▒░░░░░░░░░░░░░░░░░░░░░▀▀▀████▓▓▓▓ ░░░░░░░░░░░░▒▒
        █▓▓▓█▓▒▒▒▒▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░▒▒
        █▓▓▓█▓▓▒▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░▒
        ██▓▓▓█▓█▒▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░▒▒
        █▓█▓▓█▓▓█▓▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░▒▒
         █▓██▓█▓▓█▓▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░▒▒
         █▓▓▓███▓█▓▓▒▒░░░░░░░░░░░░░░░░░░░░░░░░░░▒▒▒
          █▓▓▓▓▓▓███████░░░░░░░░░░░░░░░░░░░░░▒▒▒
          ██████▓▓▓▓▓▓▓▓▓██████░░░░░░▒▒▒▒▒▒▒
           █▓▓▓▓▓████████▓▓▓▓▓▓▓███░░░░▒
            █▓▓▓▓▓▓▓▓▓███▓████▓▓▓▓▓███░░▒
             █▓▓▓▓▓▓██▓▓▓▓████████▓▓▓▓███▒
              █▓▓▓▓▓█▓▓▓▓█████████████▓▓▓█
               █▓▓▓▓██▓▓▓████████▓██▓▓██▓▓█
                █▓▓▓█▓██▓▓█████▓▓▓▓██▓▓▓████
                 █▓▓█▓▓▓███▓▓▓▓█████▓▓▓▓▓▓▓█
                  ▀█████▓▓▓███▓▓▓█▓▓▓▓▓▓▓▓█▀
                  ▄█▓▓█▓▓██▓▓▓████████▓▓▓█▀
                ▄██▓▓▓█▓▓▓▓███▓▓▓▓▓▓▓▓██▀
                 █▓█▓▓▓▓█▓▓▓▓▓▓███████▀
                 █▓▓██▓▓▓██▓▓▓▓▓▓▓▓█▀
                  █▓▓▓▓██▓▓██▓▓▓▓▓█▀
                   █▓▓▓▓▓██▓▓█████
                    █▓▓▓▓▓▓▓████▀
                     ▀█▓▓▓▓▓▓▓█▀
                       ▀█▓▓▓▓▓█
                         ▀▀███
                             ▀
 */
